import { render, staticRenderFns } from "./ownerOweFees.vue?vue&type=template&id=1bf0cf38&scoped=true"
import script from "./ownerOweFees.vue?vue&type=script&lang=js"
export * from "./ownerOweFees.vue?vue&type=script&lang=js"
import style0 from "./ownerOweFees.vue?vue&type=style&index=0&id=1bf0cf38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf0cf38",
  null
  
)

export default component.exports